import { useT } from '@hooks';
import React from 'react';
import s from './index.module.scss';
import checkTheme from '../../../../../src/utils/custom/checkTheme';

function SpecialFeatures() {
	const { T } = useT();
	return (
		<div className={`${s.specialFeatures} ${s[checkTheme()]}`}>
			<h2 className={s.specialFeatures_title}>{T('special_features')}</h2>
			<ul className={s.specialFeatures_items}>
				<li className={s.specialFeatures_item}>
					<span className={s.icon}>🎁 </span> {T('secret_tips')}
				</li>
				<li className={s.specialFeatures_item}>
					<span className={s.icon}>🎁 </span> {T('easy_to_cook')}
				</li>
			</ul>
		</div>
	);
}

export default SpecialFeatures;
